// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navigation_nav__1-Z3V","navItem":"Navigation_navItem__WaR9w","active":"Navigation_active__2n6VA","fadeIn":"Navigation_fadeIn__2cB19"};